module.exports = __webpack_public_path__ + "img/build-category-icon.b73d6f54.svg";